var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuardWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00039 0.0429688L7.60039 1.78842V4.40661C7.60039 6.82842 6.06439 9.09315 4.00039 9.64297C1.93639 9.09315 0.400391 6.82842 0.400391 4.40661V1.78842L4.00039 0.0429688ZM4.00039 0.994242L1.20039 2.3557V4.50261C1.20039 6.3877 2.50039 8.33388 4.00039 8.77024C5.50039 8.33388 6.80039 6.3877 6.80039 4.50261V2.3557L4.00039 0.994242ZM5.60039 5.7157V6.40951C5.58439 6.50551 5.51239 6.57097 5.41239 6.58842H2.58839C2.48839 6.57097 2.41639 6.50551 2.40039 6.40951V5.7157H5.60039ZM6.00039 3.09751L5.60039 5.27933H2.40039L2.00039 3.09751L3.06839 4.26261L4.00039 3.24588L4.93239 4.26261L6.00039 3.09751Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardWhite);
export default __webpack_public_path__ + "static/media/guard-white.06771581f41c49c8362f3417934e1ed4.svg";
export { ForwardRef as ReactComponent };